import {
    createMountsGlazingGasketConfig,
    createMountsKompasFrameConfig,
    createMountsKompasHorizontalConfig,
    createMountsKompasMullionsConfig,
    createMountsKompasVerticalConfig,
    // createMountsMullionsVerticalConfig,
} from "../../base";

import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createNoDoorMountsKompasFrameConfig = (
    partition: Partition,
): IComponentConfig => {
    const perimeter = MountsService.getPertimetr(partition);
    const qty = 4;

    return createMountsKompasFrameConfig()
        .qty(qty)
        .width(perimeter)
        .area(perimeter)
        .build();
};

const createNoDoorMountsKompasHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const lines = MountsService.getKompasHorizontalLines();
    const length = MountsService.getKompasHorizontallLinesLength(partition, lines);

    return createMountsKompasHorizontalConfig()
        .qty(lines)
        .width(width)
        .area(length)
        .build();
};

const createNoDoorMountsKompasVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const height = MountsService.getTotalHeight(partition);
    const lines = MountsService.getKompasVerticalLines(partition);
    const length = MountsService.getKompasVerticalLinesLength(partition, lines);

    return createMountsKompasVerticalConfig()
        .qty(lines)
        .width(height)
        .area(length)
        .build();
};

const createNoDoorMountsKompasMullionsConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);

    return createMountsKompasMullionsConfig()
        .qty(0)
        .width(width)
        .area(0)
        .build();
};

const createNoDoorMountsKompasGlazingGasketsConfig = (
    partition: Partition,
): IComponentConfig => {
    const verticalLines = MountsService.getKompasVerticalLines(partition);
    const horizontalLines = MountsService.getKompasHorizontalLines();

    const totalPerimetr = MountsService.getPertimetr(partition);
    const verticalLinesLength = MountsService.getKompasVerticalLinesLength(
        partition,
        verticalLines,
    );
    const horizontalLinesLength = MountsService.getKompasHorizontallLinesLength(
        partition,
        horizontalLines,
    );

    const total = Math.round(totalPerimetr + verticalLinesLength + horizontalLinesLength) || 0;

    return createMountsGlazingGasketConfig()
        .qty(0)
        .width(total)
        .area(total)
        .build();
};

export const KompasNoDoorsConfigs = (partition: Partition) => [
    createNoDoorMountsKompasFrameConfig(partition),
    createNoDoorMountsKompasHorizontalConfig(partition),
    createNoDoorMountsKompasVerticalConfig(partition),
    createNoDoorMountsKompasMullionsConfig(partition),
];
